// extracted by mini-css-extract-plugin
export var blue = "_17-h";
export var brand = "_17-d";
export var darkGrey = "_17-g";
export var disabled = "_17-6";
export var disabledSubtle = "_17-7";
export var error = "_17-8";
export var green = "_17-i";
export var grey = "_17-f";
export var icon = "_17-0";
export var inherit = "_17-c";
export var lightGrey = "_17-e";
export var orange = "_17-k";
export var pink = "_17-m";
export var primary = "_17-1";
export var purple = "_17-n";
export var quaternary = "_17-4";
export var quinary = "_17-5";
export var red = "_17-l";
export var secondary = "_17-2";
export var success = "_17-b";
export var tertiary = "_17-3";
export var warning = "_17-9";
export var warningSecondary = "_17-a";
export var white = "_17-o";
export var yellow = "_17-j";